import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { AppBar as MuiAppBar, Typography, } from '@mui/material';
const CopyrightBarWidget = ({ showCopyrightText, }) => (_jsx(MuiAppBar, { position: "static", elevation: 0, color: "transparent", sx: {
        minHeight: 48,
        pt: 1.5,
        pb: 1,
        backgroundColor: (t) => (t.portal.footer.background.color),
        color: 'common.white',
        textAlign: 'center',
    }, children: showCopyrightText && (_jsx(Typography, { children: "Copyright \u00A9 2023 Microcasting. All rights reserved." })) }));
CopyrightBarWidget.defaultProps = {
    showCopyrightText: true,
};
CopyrightBarWidget.meta = {
    group: 'hidden',
    name: 'Copyright Bar',
    description: 'Copyright Bottom Bar for the Portal',
    props: [
        {
            key: 'showCopyrightText',
            name: 'Show Copyright Text',
            type: 'boolean',
            description: 'Show copyright text on footer bar',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'AppBar',
        props: {
            showCopyrightText: true,
        },
    },
};
export default observer(CopyrightBarWidget);
//# sourceMappingURL=CopyrightBarWidget.js.map